import React, { useEffect } from "react";
import Likert, { LikertFollowUpMultiSelectAnswer, Scale as LikertScale } from "./components/likert";
import { QuestionProps } from "../survey";

interface Answer {
  value: LikertScale;
  followUpResponse?: string | LikertFollowUpMultiSelectAnswer;
}
export default function Nps({
  customizations,
  currentAnswer,
  updateAnswer,
  setAbleToSubmit,
}: QuestionProps<
  Answer,
  {
    prompt: string;
    followUpLowScore: boolean;
    followUpPrompt?: string;
    description?: string;
  }
>) {
  const label = customizations.prompt;
  const description = customizations.description;
  const followUpLowScore = customizations.followUpLowScore;
  const answerIsValid = typeof currentAnswer?.value !== "undefined";
  useEffect(() => {
    setAbleToSubmit(answerIsValid);
  }, [answerIsValid, setAbleToSubmit]);

  return (
    <div className="nps">
      {followUpLowScore ? (
        <Likert
          value={currentAnswer ? currentAnswer.value : undefined}
          prompt={label}
          description={description}
          onChangeValue={(newValue) =>
            updateAnswer(
              currentAnswer ? { ...currentAnswer, value: newValue } : { value: newValue }
            )
          }
          followUpLowScore={true}
          followUpPrompt={customizations.followUpPrompt}
          followUpResponse={
            currentAnswer && currentAnswer.followUpResponse ? currentAnswer.followUpResponse : ""
          }
          onChangeLowFollowUp={(newResponse) => {
            if (!currentAnswer)
              throw new Error("Attempted to update NPS low score follow up without a score");
            updateAnswer({ ...currentAnswer, followUpResponse: newResponse });
          }}
        />
      ) : (
        <Likert
          value={currentAnswer ? currentAnswer.value : undefined}
          prompt={label}
          description={description}
          onChangeValue={(newValue) =>
            updateAnswer(
              currentAnswer ? { ...currentAnswer, value: newValue } : { value: newValue }
            )
          }
          followUpLowScore={false}
        />
      )}
    </div>
  );
}
